/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Return_Lot_PrefixInputs */

const vi_confirm_return_lot_prefix = /** @type {(inputs: Confirm_Return_Lot_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô`)
};

/**

* @param {Confirm_Return_Lot_PrefixInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const confirm_return_lot_prefix = /** @type {((inputs?: Confirm_Return_Lot_PrefixInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Return_Lot_PrefixInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_confirm_return_lot_prefix(inputs)
});